var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "#001E3C"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 15.423c-.13 0-.25-.05-.35-.14l-6.5-6.42c-.2-.19-.2-.51 0-.71.19-.2.51-.2.71 0l6.14 6.07 6.15-6.08c.2-.19.51-.19.71 0 .19.2.19.51 0 .71l-6.5 6.43c-.1.1-.22.14-.35.14z"
})));
export { SvgArrowDown as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiYjk5ZmFiODJjYmQzMjA3MjM5NGY2ODFmOWYzYzExOWYuc3ZnIjs=";